import clx from 'classnames';
import { EDITO_WIDGET_X_PADDING } from 'components/widgets/const';
import { useCmsData } from 'utils/cms';

const PushMobileApp = () => {
  const {
    generalSettings: { apps_mobile: appsMobile },
  } = useCmsData();

  return (
    <div className={clx('flex md:flex-row flex-col gap-3 items-center w-fit m-auto', EDITO_WIDGET_X_PADDING)}>
      {appsMobile &&
        appsMobile?.map((app) => (
          <a key={app.app_link.url} aria-label={app.app_link.title} href={app.app_link.url}>
            <img alt={app.app_logo.alt} className="h-12" height={48} src={app.app_logo.sizes.medium} />
          </a>
        ))}
    </div>
  );
};

export default PushMobileApp;
